function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-lines */
/* eslint-disable max-statements */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useMemo, useState } from 'react';

import {
  Link,

  useBlocker,
  useLoaderData,
  useNavigate,
  useRevalidator } from
'react-router';
import { useForm } from 'react-hook-form';
import { useSetAtom } from 'jotai';
import { debounce } from 'lodash';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/20/solid';
import { Translate, t } from "../../../../I18N";
import * as pagesAPI from "../../../api/pages";

import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Button, CopyValueInput, Tabs, ConfirmNavigationModal } from "../../../Components/UI";
import { CodeEditor } from "../../../Components/CodeEditor";
import { EnableButtonCheckbox, InputField } from "../../../Components/Forms";
import { notificationAtom } from "../../../atoms";
import { FetchResponseError } from "../../../../../shared/JSONRequest";
import { getPageUrl } from "./components/PageListTable";
import { HTMLNotification, JSNotification } from "./components/PageEditorComponents";

const pageEditorLoader =
(headers) =>
async ({ params }) => {
  if (params.sharedId) {
    const page = await pagesAPI.getBySharedId(params.sharedId, headers);

    return page;
  }

  return {};
};

const PageEditor = () => {var _page$metadata, _page$metadata2;
  const page = useLoaderData();
  const revalidator = useRevalidator();
  const navigate = useNavigate();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const setNotifications = useSetAtom(notificationAtom);

  const debouncedChangeHandler = useMemo(() => (handler) => debounce(handler, 500), []);

  const {
    register,
    formState: { errors, dirtyFields, isSubmitting },
    watch,
    getValues,
    setValue,
    handleSubmit
  } = useForm({
    defaultValues: { title: t('System', 'New page', null, false) },
    values: page
  });

  const isDirty = !!Object.keys(dirtyFields).length;
  const blocker = useBlocker(isDirty && !isSubmitting);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      setShowConfirmationModal(true);
    }
  }, [blocker, setShowConfirmationModal]);

  const notify = (response) => {
    const hasErrors = response instanceof FetchResponseError;

    setNotifications(_objectSpread({
      type: !hasErrors ? 'success' : 'error',
      text: !hasErrors ? /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Saved successfully.") : /*#__PURE__*/

      _jsx(Translate, {}, void 0, "An error occurred") },

    hasErrors && { details: response.message })
    );
  };

  const handleRevalidate = async (response) => {
    if (!page.sharedId) {
      await navigate(`/${response.language}/settings/pages/edit/${response.sharedId}`, {
        replace: true
      });
    } else {
      await revalidator.revalidate();
    }
  };

  const save = async (data) => {
    const response = await pagesAPI.save(data);

    return response;
  };

  const handleSave = async (data) => {
    const response = await save(data);
    const hasErrors = response instanceof FetchResponseError;

    notify(response);

    if (!hasErrors) {
      await handleRevalidate(response);
    }
  };

  const handleSaveAndPreview = async (data) => {
    const response = await save(data);
    const hasErrors = response instanceof FetchResponseError;

    notify(response);

    if (!hasErrors) {
      const pageUrl = getPageUrl(response.sharedId, response.title);
      window.open(`${window.location.origin}/${pageUrl}`);
      await handleRevalidate(response);
    }
  };

  return (/*#__PURE__*/
    _jsx("div", { className: "tw-content", style: { width: '100%', height: '100%', overflowY: 'auto' } }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, {
      path: new Map([['Pages', '/settings/pages']]),
      title: watch('title') }
    ), /*#__PURE__*/

    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(Tabs, { unmountTabs: false }, void 0, /*#__PURE__*/
    _jsx(Tabs.Tab, { id: "Basic", label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Basic") }, void 0, /*#__PURE__*/
    _jsx("form", {}, void 0, /*#__PURE__*/
    React.createElement("input", _extends({ className: "hidden" }, register('sharedId'))), /*#__PURE__*/
    _jsx("div", { className: "flex flex-col max-w-2xl gap-4" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex items-center gap-4" }, void 0, /*#__PURE__*/
    _jsx(Translate, { className: "font-bold" }, void 0, "Enable this page to be used as an entity view page:"

    ), /*#__PURE__*/
    React.createElement(EnableButtonCheckbox, _extends({},
    register('entityView'), {
      defaultChecked: page.entityView })
    )
    ), /*#__PURE__*/

    React.createElement(InputField, _extends({
      id: "title",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Title") },
    register('title', { required: true }), {
      hasErrors: errors.title !== undefined,
      errorMessage: errors.title && /*#__PURE__*/_jsx(Translate, {}, void 0, "This field is required") })
    ), /*#__PURE__*/

    _jsx(CopyValueInput, {
      value:
      !getValues('entityView') && getValues('sharedId') ?
      `/${getPageUrl(getValues('sharedId'), getValues('title'))}` :
      '',

      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "URL"),
      className: "w-full mb-4",
      id: "page-url" }
    ),

    getValues('sharedId') && !getValues('entityView') && /*#__PURE__*/
    _jsx(Link, {
      target: "_blank",
      to: `/${getPageUrl(getValues('sharedId'), getValues('title'))}` }, void 0, /*#__PURE__*/

    _jsx("div", { className: "flex gap-2 hover:font-bold hover:cursor-pointer" }, void 0, /*#__PURE__*/
    _jsx(ArrowTopRightOnSquareIcon, { className: "w-4" }), /*#__PURE__*/
    _jsx(Translate, { className: "underline hover:text-primary-700" }, void 0, "View page"

    )
    )
    )

    )
    )
    ), /*#__PURE__*/

    _jsx(Tabs.Tab, { id: "Code", label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Markdown") }, "html", /*#__PURE__*/
    _jsx("div", { className: "flex flex-col h-full gap-2" }, void 0, /*#__PURE__*/
    _jsx(HTMLNotification, {}), /*#__PURE__*/
    _jsx("div", { className: "h-full pt-2" }, void 0, /*#__PURE__*/
    _jsx(CodeEditor, {
      language: "html",
      intialValue: (_page$metadata = page.metadata) === null || _page$metadata === void 0 ? void 0 : _page$metadata.content,
      onMount: (editor) => {var _editor$getModel;
        (_editor$getModel = editor.getModel()) === null || _editor$getModel === void 0 ? void 0 : _editor$getModel.onDidChangeContent(
          debouncedChangeHandler(() => {
            setValue('metadata.content', editor.getValue(), { shouldDirty: true });
          })
        );
      },
      fallbackElement: /*#__PURE__*/
      React.createElement("textarea", _extends({}, register('metadata.content'), { className: "w-full h-full" })) }

    )
    )
    )
    ), /*#__PURE__*/

    _jsx(Tabs.Tab, { id: "Advanced", label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Javascript") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col h-full gap-2" }, void 0, /*#__PURE__*/
    _jsx(JSNotification, {}), /*#__PURE__*/
    _jsx("div", { className: "h-full pt-2" }, void 0, /*#__PURE__*/
    _jsx(CodeEditor, {
      language: "javascript",
      intialValue: (_page$metadata2 = page.metadata) === null || _page$metadata2 === void 0 ? void 0 : _page$metadata2.script,
      onMount: (editor) => {var _editor$getModel2;
        (_editor$getModel2 = editor.getModel()) === null || _editor$getModel2 === void 0 ? void 0 : _editor$getModel2.onDidChangeContent(
          debouncedChangeHandler(() => {
            setValue('metadata.script', editor.getValue(), { shouldDirty: true });
          })
        );
      },
      fallbackElement: /*#__PURE__*/
      React.createElement("textarea", _extends({}, register('metadata.script'), { className: "w-full h-full" })) }

    )
    )
    )
    )
    )
    ), /*#__PURE__*/

    _jsx(SettingsContent.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex justify-end gap-2" }, void 0, /*#__PURE__*/
    _jsx(Link, { to: "/settings/pages" }, void 0, /*#__PURE__*/
    _jsx(Button, { styling: "light", disabled: isSubmitting }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    )
    ), /*#__PURE__*/

    _jsx(Button, {
      styling: "solid",
      color: "primary",
      onClick: handleSubmit(handleSaveAndPreview),
      disabled: getValues('entityView') || isSubmitting }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Save & Preview")
    ), /*#__PURE__*/

    _jsx(Button, {
      styling: "solid",
      color: "success",
      onClick: handleSubmit(handleSave),
      disabled: isSubmitting }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Save")
    )
    )
    )
    ),

    showConfirmationModal && /*#__PURE__*/
    _jsx(ConfirmNavigationModal, {
      setShowModal: setShowConfirmationModal,
      onConfirm: blocker.proceed }
    )

    ));

};

export { PageEditor, pageEditorLoader };